import * as deepLinks from 'actions/deepLinks';

const defaultState = {
  status: 'UNLOADED',
  deepLink: {},
};

export default function deepLinksReducer(state = defaultState, action) {
  switch (action.type) {
    case deepLinks.LOAD_START:
      return { status: 'LOADING' };
    case deepLinks.LOAD_SUCCESS:
    case deepLinks.REFRESH_SUCCESS:
      return { status: action.payload.status, deepLink: action.payload };
    case deepLinks.LOAD_FAIL:
    case deepLinks.REFRESH_FAIL:
      return { status: 'FAILED', error: action.payload };
    case deepLinks.TOKEN_EXPIRED:
      return { status: 'EXPIRED', deepLink: action.payload };
    case deepLinks.RESET_DEEP_LINKS:
      return { ...defaultState };
    default:
      return state;
  }
}
